export const LogoMark = ({ size = 36, className = "" }) => (
  <img
    src="/logo-mark.png"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    data-testid="logo-mark"
    alt="Aaravya Impex logo"
  />
);
